<template>
	<div>
		<div class="TopSearch">
			<FromComm :FromArr="FromArr"></FromComm>
			<div class="btngroup">
				<CommonBtngroup ref="btngroup" :qhide="false" @select="handSearch" @reset="handReset"></CommonBtngroup>
			</div>
		</div>
		<div class="ContentView_CheckVouch">
			<div class="BottomTable">
				<Commonbtn v-if="nodeAuth.includes('delete')" backgroundColor="#FFF" title="删除" fontSize="14px"
					@btnclick="handleDel" :src="require('@/assets/icon/icon-del.png')">
				</Commonbtn>
				<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="handExport"
					:src="require('@/assets/icon/daoc.png')" />
			</div>
			<div class="custom-table">
				<el-table ref="tableRef" :data="tableData" style="width: 100%;" highlight-current-row
					@selection-change="(e)=>selectedList = e" @current-change="handleDetail">
					<el-table-column type="selection" width="55" />
					<el-table-column prop="StatusName" label="状态" width="70" />
					<el-table-column prop="VouCode" label="单据号" width="100" />
					<el-table-column prop="DLDate" label="消耗日期" width="110" />
					<el-table-column prop="InvClassName" label="产品线" width="120" />
					<el-table-column prop="CusName" label="付款方" />
					<el-table-column prop="TerminalHospitalName" label="终端医院" />
					<el-table-column prop="TechnicalOffices" label="科室" width="100px" />
					<el-table-column prop="SurgeryDate" label="手术日期" width="110px" />
					<el-table-column prop="Doctor" label="术者" width="80" />
					<el-table-column prop="SurgeryType" label="手术类型" width="100" />
					<el-table-column prop="CreateTime" label="上报日期" width="110" />
					<el-table-column prop="VerifyTime" label="付款日期" width="110" />
				</el-table>
			</div>
			<div class="pagination">
				<Pagination ref="invPagination" type='allColor' :pageSize="query.pageSize"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
				</Pagination>
			</div>
		</div>

		<div class="ContentView_CheckVouch" style="padding-top:24px;margin:24px 0px 200px;" v-if="tableData2.length">
			<div class="custom-table">
				<el-table ref="tableRef" :data="tableData2" style="width: 100%;">
					<el-table-column prop="InvAddCode" label="产品型号" />
					<el-table-column prop="InvName" label="产品名称" />
					<el-table-column prop="Batch" label="批号" />
					<el-table-column prop="ValiDate" label="有效期至" />
					<el-table-column prop="Quantity" label="数量" />
					<el-table-column prop="TaxUnitPrice" label="含税单价" />
					<el-table-column prop="Sum" label="价税合计" />
					<el-table-column prop="InvUniqueCode" label="唯一码" />
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
	import FromComm from '../../views/home/components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Commonbtn from '../../../components/common-btn.vue'
	import Pagination from '../../../components/pagination.vue'
	import CommonbtnUpLoad from '../../../components/common-upload.vue'
	import Commontable from '../../../components/common-table.vue'
	import FromArr from './FormData/FromArr'
	import utils from '../../../common/utils'
	import DialogFrom from '../../../components/dialog-from.vue'
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import {
		GetSmsDispatchList,
		ExportSmsDispatchData,
		DeleteSmsDispatchData,
		GetSmsDispatchDetail,
		GetHelperPayStatus
	} from '@/api/channel'
	import {
		InventoryClassList
	} from '@/api/home'
	export default {
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			Pagination,
			CommonbtnUpLoad,
			Commontable,
			DialogFrom,
			Commondropdownlist
		},
		computed: {
			CusType() {
				return this.$store.state.MenusData.CusType;
			},
			menusData() {
				return this.$store.state.MenusData.Menus;
			}
		},
		data() {
			return {
				total: 0,
				query: {
					pageIndex: 1,
					pageSize: 10
				},
				FromArr: [],
				tableData: [],
				dialogVisible: false,
				selectedList: [],
				nodeAuth: [],
				tableData2: []
			}
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArr[8].StartTime = this.$utils.getFYearDate();
			this.InventoryClassList();
			this.getData();
			this.StatusList();
			this.setMenuList();
		},
		methods: {
			setMenuList() {
				let NodeInfo = this.menusData.filter(item => item.NodeID === '24')[0].Nodes.filter(item => item.NodeID ===
					'1084')[0];
				this.nodeAuth = NodeInfo.Nodes && NodeInfo.Nodes.map(item => item.NodeName);
			},
			//查询列表数据
			async getData() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});


				this.query.CusName = this.FromArr[0].modelvalue;
				this.query.VouCode = this.FromArr[1].modelvalue;
				this.query.TerminalHPName = this.FromArr[2].modelvalue;
				this.query.InvClass = this.FromArr[3].modelvalue ? this.FromArr[3].modelvalue.join(',') : '';
				this.query.Status = this.FromArr[4].modelvalue;

				this.query.InvAddCode = this.FromArr[5].modelvalue;
				this.query.InvName = this.FromArr[6].modelvalue;
				this.query.Batch = this.FromArr[7].modelvalue;

				this.query.DLDate1 = this.FromArr[8].StartTime;
				this.query.DLDate2 = this.FromArr[8].EndTime;
				this.query.VerifyTime1 = this.FromArr[9].StartTime;
				this.query.VerifyTime2 = this.FromArr[9].EndTime;
				this.query.CreateTime1 = this.FromArr[10].StartTime;
				this.query.CreateTime2 = this.FromArr[10].EndTime;


				let {
					code,
					data,
					message
				} = await GetSmsDispatchList(this.query)
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data.map(it => {
						it.DLDate = it.DLDate ? it.DLDate.substring(0, 10) : '';
						it.VerifyTime = it.VerifyTime ? it.VerifyTime.substring(0, 10) : '';
						it.CreateTime = it.CreateTime ? it.CreateTime.substring(0, 10) : '';
						it.SurgeryDate = it.SurgeryDate ? it.SurgeryDate.substring(0, 10) : '';
						return it;
					});
					loading.close();
				} else {
					loading.close();
					this.$message.error(message);
				}
			},
			//详情
			async handleDetail(e) {
				let {
					code,
					data,
					message
				} = await GetSmsDispatchDetail({
					DLMID: e.DLMID
				})
				if (code == 0) {
					this.tableData2 = data;
				} else {
					this.$message.error(message);
				}
			},
			// 产品线下拉
			async InventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({});
				if (code == 0) {
					this.FromArr[3].options = []
					data.data.map((item, index) => {
						this.FromArr[3].options.push({
							key: item.InvClass,
							value: item.InvClassName
						})
					})
				}
			},
			// 状态下拉
			async StatusList() {
				let {
					code,
					data
				} = await GetHelperPayStatus({});
				if (code == 0) {
					this.FromArr[4].options = []
					data.map((item, index) => {
						this.FromArr[4].options.push({
							key: item.Value,
							value: item.Text
						})
					})
				}
			},
			//导出
			async handExport(e) {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				this.query.CusName = this.FromArr[0].modelvalue;
				this.query.VouCode = this.FromArr[1].modelvalue;
				this.query.TerminalHPName = this.FromArr[2].modelvalue;
				this.query.InvClass = this.FromArr[3].modelvalue ? this.FromArr[3].modelvalue.join(',') : '';
				this.query.Status = this.FromArr[4].modelvalue;

				this.query.InvAddCode = this.FromArr[5].modelvalue;
				this.query.InvName = this.FromArr[6].modelvalue;
				this.query.Batch = this.FromArr[7].modelvalue;

				this.query.DLDate1 = this.FromArr[8].StartTime;
				this.query.DLDate2 = this.FromArr[8].EndTime;
				this.query.VerifyTime1 = this.FromArr[9].StartTime;
				this.query.VerifyTime2 = this.FromArr[9].EndTime;
				this.query.CreateTime1 = this.FromArr[10].StartTime;
				this.query.CreateTime2 = this.FromArr[10].EndTime;

				let resexprot = await ExportSmsDispatchData(this.query)
				loading.close();
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `已消耗未付款${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			async handleDel() {
				if (!this.selectedList.length) {
					this.$message.warning('请勾选');
					return;
				}
				let {
					code,
					data,
					message
				} = await DeleteSmsDispatchData({
					DLMIDs: this.selectedList.map(it => it.DLMID),
				});
				if (code == 0) {
					this.selectedList = [];
					this.$message.warning('删除成功');
					this.getData();
					this.$refs.tableRef.clearSelection();
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message.error(message);
					}
				}
			},
			handSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			handReset() {
				this.query = {
					pageIndex: 1,
					pageSize: 10
				};
				this.FromArr.map((item, index) => {
					item.modelvalue = '';
					item.StartTime = '';
					item.EndTime = '';
					return item;
				})
				this.getData();
			},
			handleCurrentChange(e) {
				this.query.pageIndex = e
				this.getData()
			},
			handleSizeChange(e) {
				this.query.pageSize = e
				this.getData()
			}
		},
	}
</script>

<style lang="less" scoped>
	.TopSearch {
		height: 240px;
		margin: 0px 0px 8px;
		background: #FFFFFF;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

		.btngroup {
			// border: 1px solid #0b65ec;
			position: relative;
			//bottom: 21px;
		}
	}

	.ContentView_CheckVouch {
		background: #FFFFFF;

		.BottomTable {
			padding: 10px 0px;
		}

		.ativte {
			border: 1px solid red;
			color: #e71d43;
			background-color: #fce8ec;
			transition: 0.2s linear;
		}

		.incenters {
			padding: 14px 4px;

			div {
				margin-left: 8px;
				margin-right: 8px;
				margin-top: 5px;
				margin-bottom: 5px;
				// width: 100%;
			}
		}

		.topstate {
			width: 100px;
			height: 32px;
			font-size: 14px;
			border: 1px solid #e6e6e6;
			line-height: 32px;
			text-align: center;
			cursor: pointer;
			display: inline-block;
			user-select: none;
		}

		.custom-table {
			padding: 0px 0px 24px 0px;

			/deep/.el-table .el-table__cell {
				padding: 8px 0;

				.cell {
					.update_ipt {
						.el-input__inner {
							height: 28px;
							line-height: 28px;
							border-radius: 0px;
						}

						.el-input__inner:focus {
							border-color: #e71d43;
						}
					}

					.table-export {
						color: #e71d43;
						cursor: pointer;
					}
				}
			}

			/deep/.el-table th.el-table__cell {
				background: #F3F3F3;
			}


			/deep/.el-table {
				.el-checkbox__input.is-checked .el-checkbox__inner,
				.el-checkbox__input.is-indeterminate .el-checkbox__inner {
					background-color: #e71d43;
					border-color: #e71d43;
				}
			}

			// /deep/.el-table__body {
			// 	td {
			// 		padding: 0px 0 !important;
			// 		cursor: pointer;
			// 	}
			// }
		}

	}

	.from-table {
		//padding: 0px 24px 24px 24px;

		/deep/.el-table .el-table__cell {
			padding: 8px 0;
		}

		/deep/.el-table th.el-table__cell {
			background: #F3F3F3;
		}
	}
</style>